import RedirectToDocument from "../components/RedirectToDocument";
import ProtectedComponent from "../components/ProtectedComponent";
import ScreenPage from "../pages/ScreenPage";
import DashboardPage from "../pages/DashboardPage";
import DocumentPage from "../pages/DocumentPage";
import LoginPage from "../pages/LoginPage";
import BelgeSorgulama from "../pages/BelgeSorgulama";

const routes = [
  { path: "/sign-in", element: <LoginPage /> },
  {
    path: "/",
    element: (
      <ProtectedComponent>
        <DashboardPage />
      </ProtectedComponent>
    ),
  },
  {
    path: "/belge-sorgulama",
    element: (
      <>
        <BelgeSorgulama />
      </>
    ),
  },
    {
    path: "/koleksiyon-olustur",  
    element: (
      <ProtectedComponent>
        <DashboardPage />
      </ProtectedComponent>
    ),
  },
    {
    path: "/belgeleri-yonet",   
    element: (
      <ProtectedComponent>
        <DashboardPage />
      </ProtectedComponent>
    ),
  },
  {
    path: "/redirect/:documentId",
    element: (
      <>
        <RedirectToDocument />
      </>
    ),
  }, 
  { path: "/screens/:screenId", element: <ScreenPage /> },
  {
    path: "/screens/:screenId/documents/:documentId",
    element: (
      <>
        <DocumentPage />
      </>
    ),
  },
  {
    path: "/belgelerim/:documentId",
    element: (
      <>
        <DocumentPage />
      </>
    ),
  },
];

export default routes;
